<template>

  <nav class="navbar navbar-expand-lg navbar-light bg-light  shadow mx-auto nav-503-parent">
    <m-a :href="{name:'Home'}" class="navbar-brand">
      <m-img :src="findAttributeOnSiteInfo('icon')[0]" :alt="findAttributeOnSiteInfo('site_name')[0]" class="logo"/>
    </m-a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse " id="navbarNavAltMarkup">
      <div class="col-12">
        <div class="row mx-auto align-items-center justify-content-between ">
          <div class="navbar-nav col-lg-7 col-md-11">


            <m-menu3 class="d-inline-block nav307-menu" :menu-position="menuPosition">


            </m-menu3>


          </div>
          <div class="col-lg-5  text-lg-left p-0 ">
            <div class="text-center ml-1 nav-503-search-wrapper">
              <m-search-input-2 class="mx-auto nav-503-search"/>
            </div>

            <template v-if="shoppingCart">

              <div v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1" class="shopping-button-parent p-1 ">

                <router-link class="text-decoration-none " :to="{name:'ShoppingCart'}">
                  <button class="btn d-flex align-items-center position-relative shopping-button">
                    <i class="bi bi-bag font-weight-bold text-muted  "></i>
                    <m-shopping-cart-counter1/>
                  </button>
                </router-link>

              </div>


              <div v-else class="shopping-button-parent p-1  ">
                <router-link class="text-decoration-none" :to="{ name: 'UnAuthenticatedShoppingCart' }">
                  <button class="btn d-flex  align-items-center position-relative shopping-button">
                    <i class="bi bi-bag font-weight-bold text-muted "></i>
                    <m-shopping-cart-counter1/>
                  </button>
                </router-link>
              </div>

            </template>

            <slot>
              <span class="btn btn-primary my-1">ثبت نام </span>
              <span class="btn btn-primary">درخواست مشاوره </span>
            </slot>
          </div>
        </div>


      </div>
    </div>
  </nav>


</template>

<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";
import mA from '../../Tags/A'
import mImg from '../../Tags/Img.vue'
import mMenuIconManager from "../../Menu/MenuIconManager.vue";
import mMenu3 from "../../Menu/Menu3.vue";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1.vue";
import mSearchInput2 from "../../Search/Input/SearchInput2.vue";

export default {
  name: "Nav5",
  components: {mSearchInput2, mShoppingCartCounter1, mMenu3, mMenuIconManager, NavMenuItem, mA, mImg},
  props: {
    menuPosition: {
      default: 'blog_nav'
    },
    shoppingCart: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
    })
  },
  mounted() {

  },
}
</script>

<style scoped>

.logo {
  height: 50px;
}

.navbar {
  border-radius: 15px;
}


.nav-503-parent :deep(.menu-icon-manager) {

  height: 20px;
  width: 18px;
  object-fit: contain;
  margin: 0 5px;

}


.nav-503-parent :deep(.dropdown:hover .dropdown-menu:not(.show)) {
  opacity: 0;
  transform: translateY(10px);
  visibility: hidden;
  transition-delay: 0s, 0s, 0.3s; /* Delays visibility to allow opacity and transform transitions */
}

.nav-503-parent :deep(.dropdown-menu.show) {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  position: absolute;
}

.nav-503-parent :deep(.dropdown-menu) {
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  display: block;
  visibility: hidden; /* Keeps the element out of sight when closed */
  border-radius: 10px;
  position: absolute;
}


.nav-503-parent :deep(.base-menu-item-wrapper) {
  margin-bottom: 10px !important;
}

.nav-503-search-wrapper {
  display: inline-block;

}


.nav-503-parent :deep(.dropdown-item) {
  text-align: center !important;
}

.nav-503-parent :deep(.search-input-2-icon) {
  font-size: 20px;
}

.shopping-button-parent .bi {
  font-size: 21px;
}

.shopping-button {
  padding: 0;
}

.shopping-button-parent {
  display: inline-block !important;
}


@media only screen and (max-width: 900px) {
  .nav-503-parent :deep(.base-menu-item-wrapper) {
    display: block !important;
  }

  .nav-503-parent .nav-503-search {
    display: inline-block;
  }

  .nav-503-search-wrapper {
    display: block;
  }

  .shopping-button-parent {
    display: block !important;
    text-align: center;
  }

  .shopping-button-parent a {
    display: inline-block;
    margin: auto;
  }

}

.nav-503-parent :deep(#menu-3 .base-menu-item-wrapper) {
  margin: 10px !important;
}


</style>
